import type { EventListItemDTO } from '~/shared/api/client/events/events.dto';

type EventDates = Pick<
  EventListItemDTO,
  'start_time' | 'end_time' | 'end_time_specified' | 'month_only'
>;

/**
 * schema.org Event dates: a month-only event gets a year-month start
 * and no end, an event without an exact end time gets a date-only end.
 */
export function getEventSeoDates(event: EventDates): {
  startDate: string;
  endDate?: string;
} {
  if (event.month_only) {
    return { startDate: event.start_time.slice(0, 7) };
  }

  return {
    startDate: event.start_time,
    endDate:
      event.end_time_specified === false
        ? event.end_time.slice(0, 10)
        : event.end_time,
  };
}
